<template>
    <div
        v-if="!shouldHide"
        @mouseover="isHovering = true"
        @mouseleave="isHovering = false"
        class="group-menu-item"
    >
        <div class="group-menu-item-text">
            <typo name="menu-14-normal">
                {{ item.label }}
            </typo>
            <chevron v-if="groupItems && groupItems.length > 0" />
        </div>
        <transition
            name="mag-sub-menu-groups-transition"
            v-if="groupItems && groupItems.length > 0"
        >
            <div v-if="isHovering" class="group-submenu" ref="groupSubmenu">
                <router-link
                    v-for="item in groupItems"
                    :key="item.id"
                    :to="`/espace-client/mag?category=${item.name}`"
                    class="group-sub-menu-item-text"
                >
                    <typo name="menu-14-normal">
                        {{ item.title }}
                    </typo>
                </router-link>
            </div>
        </transition>
    </div>
</template>

<script>
import Chevron from "src/components/common/icons/Chevron.vue";
export default {
    props: ["item", "groupItems"],
    components: { Chevron },
    data() {
        return {
            isHovering: false,
        };
    },
    computed: {
        shouldHide() {
            const isEmpty = !this.groupItems || this.groupItems.length === 0;
            return this.item.id === "others" && isEmpty;
        },
    },
    watch: {
        isHovering(_isHovering) {
            this.$nextTick(() => {
                if (_isHovering && this.$refs.groupSubmenu) {
                    const subMenuGroupTop =
                        window.innerHeight - this.$refs.groupSubmenu.getBoundingClientRect().bottom;
                    this.$refs.groupSubmenu.style.top = `${
                        subMenuGroupTop < 0 ? subMenuGroupTop - 10 : 0
                    }px`;
                }
            });
        },
    },
};
</script>

<style lang="sass" scoped>
.group-menu-item
    display: flex
    align-items: center
    color: $color-secondary
    transition: background .15s ease, color .15s ease
    padding: 16px
    cursor: pointer
    position: relative
    &:not(:last-child)
        border-bottom: 1px solid $color-background-dark
    .group-menu-item-text
        display: flex
        justify-content: space-between
        width: 100%
    .chevron
        fill: $color-secondary
        transition: fill .15s ease, transform .15s ease-in
    &:hover
        background: $color-secondary
        color: white
        .chevron
            fill: white
            transform: translate(5px,0)

.group-submenu
    position: absolute
    width: 400px
    left: 100%
    background: #fff
    top: 0
    z-index: 9
    overflow: hidden
    box-sizing: border-box
    display: flex
    flex-direction: column
    max-height: 550px
    overflow-y: auto
    border-left:  1px solid $color-background-dark

.group-sub-menu-item-text
    padding: 16px
    transition: background .15s ease, color .15s ease
    cursor: pointer
    color: $color-secondary
    line-height: 0
    &:not(:last-child)
        border-bottom: 1px solid $color-background-dark
    &:hover
        background: $color-secondary
        color: white !important

.mag-sub-menu-groups-transition
    &-enter-active, &-leave, &-leave-to
        transition: transform .15s ease-in, opacity .15s ease-in

    &-enter, &-leave-to
        opacity: 0
        transform: translate(-5px,0)
</style>
